import React, { Component, Fragment } from "react";
import { Grid, List, Hidden, Slide, } from '@material-ui/core';

import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import Pane from './containers/Pane';
import DetailsCard from './containers/DetailsCard';
import DetailsCardModal from './containers/DetailsCardModal';
import { LoadingProgress } from './containers/LoadingProgress';
import { FilterTabs } from './containers/FilterTabs';
import { NoticeDetail } from './NoticeDetail';
import { NoticeItem } from './NoticeItem';

import { Filters } from './../services/Filters';

const _filters = new Filters();

class Notices extends Component {

  state = {
    open: false,
    enter: false,
    selectedFilter: 0,
  };

  componentDidMount() {
    this.props.onRefreshData();
  }

  componentWillUnmount() {
    this.props.onClose();
  }


  handleOpen = () => {
    this.setState({ open: true });
  };

  handleOnEnter = () => {
    this.setState({enter: true});
  }
  handleOffEnter = () => {
    this.setState({enter: false});
  }

  handleClose = () => {
    const transitionDelay = isWidthUp('md', this.props.width) ? 300 : 0;
    this.handleOffEnter();
    setTimeout(() => {
      this.setState({ open: false });
      this.props.onClose();
    },transitionDelay);
  };

  handleSelect = (id) => {
    this.props.onSelect(id);
    this.handleOnEnter();
    if (!isWidthUp('md', this.props.width)) {
      this.handleOpen();
    }
  }

  onExternalLink = (e, url) => {
    e.preventDefault();
    window.open(url);
  }

  handleItemClick = (e, url, id) => {
    if(url) {
      this.onExternalLink(e, url);
    } else {
      this.handleSelect(id);
    }
  }

  getNoticesByFilter() {
    return Object.entries(
      this.props.notices.reduce((notices, notice) => {
        const filtersArray = notice.filters.split("|");
        for(let i = 0; i < filtersArray.length; i++) {
          notices[filtersArray[i]] = notices[filtersArray[i]]
          ? [...notices[filtersArray[i]], notice]
          : [notice]
        }

        return notices;
      }, {})
    );
  }

  handleFilterSelected = selectedFilter => {
    this.setState({
      selectedFilter
    });
  };

  render() {
    const { notices,
      noticeItem,
      noticeItem: {
        id,
        date,
        type,
      },
      translations,
      appLanguage,
    } = this.props;
    const filters = this.props.filters && this.props.filters.length > 0 ? this.props.filters : null;
    const { enter, selectedFilter } = this.state;
    let pageHeading = translations.t_TITLE_NOTICES[appLanguage];
    if (notices[0]) {
      pageHeading = notices[0].type === 'kamar'
        ? translations.t_TITLE_NOTICE_KAMAR[appLanguage]
        : translations.t_TITLE_NOTICES[appLanguage];
    }
    const noticesItems = selectedFilter ? this.getNoticesByFilter().map(([filter, notices]) => {
      return selectedFilter === filter
      ? notices.map((item, i) => {
        return (
          <NoticeItem
            key={item.id ? item.id : i}
            item={item}
            appLanguage={appLanguage}
            onClick={this.handleItemClick}
          />
        )
      })
      : null
    }) : notices.map((item, i) => {
      return (
        <NoticeItem
          key={item.id ? item.id : i}
          item={item}
          appLanguage={appLanguage}
          onClick={this.handleItemClick}
        />
      )
    });
    return (
      <Fragment>
        <Grid container spacing={24} justify="center" alignItems='stretch'>
          <Grid item xs zeroMinWidth style={{maxWidth: 800}} >
            <Pane 
              header={pageHeading}
              filterTabs={
                filters !== null ?
                <FilterTabs
                  filters={filters}
                  selectedFilter={selectedFilter}
                  onFilterSelect={this.handleFilterSelected}
                />
                : null
              }
            >
              <LoadingProgress data={notices}>
                <List>
                  {noticesItems}
                </List>
              </LoadingProgress>
            </Pane>
          </Grid>

          { id ? 
            <Fragment>
              <Hidden smDown>
                <Grid item xs md={7} lg={8}>
                  <Slide direction="left" in={enter} mountOnEnter unmountOnExit>
                    <DetailsCard 
                        appLanguage={appLanguage}
                        title={noticeItem.header ? noticeItem.header : _filters.startEndDate(date, type)}
                        subheader={noticeItem.header ? _filters.startEndDate(date) : ''}
                        onClose={this.handleClose}
                      >
                      <NoticeDetail
                        type={type}
                        noticeItem={noticeItem}
                        translations={translations}
                        appLanguage={appLanguage}
                      />
                    </DetailsCard>
                  </Slide>
                </Grid>
              </Hidden>
              <DetailsCardModal
                appLanguage={appLanguage}
                ariaLabelledby="notice-modal-title"
                ariaDescribedby="notice-modal-description"
                open={this.state.open}
                onClose={this.handleClose}
                title={noticeItem.header ? noticeItem.header : _filters.startEndDate(date, type)}
                subheader={noticeItem.header ? _filters.startEndDate(date) : ''}
              >
                <NoticeDetail
                  type={type}
                  noticeItem={noticeItem}
                  translations={translations}
                  appLanguage={appLanguage}
                />
              </DetailsCardModal>
            </Fragment>
            : null
          }
        </Grid>
      </Fragment>
    );
  }
}

export default withWidth()(Notices);


// WEBPACK FOOTER //
// ./src/components/Notices.js